export default __webpack_public_path__ + "static/media/why_choose_us.916da5e3.jpg";